<!-- components/Cards/CardTipo5.vue -->

<template>
  <div
    class="relative min-w-[19rem] md:min-w-[unset] md:w-[32%] h-full flex flex-col rounded-lg shadow-lg hover:shadow-xl transition-all ease-linear duration-300 bg-white group overflow-hidden"
  >
    <div
      class="absolute right-3 top-3 z-10 inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12px] font-semibold leading-none shadow-[0_2px_6px_rgba(0,0,0,0.12)]"
      :class="clasesEtiqueta"
    >
      <svg
        v-if="oferta.es_vigente"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="h-[14px] w-[14px] shrink-0"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
      >
        <path d="M20 6 9 17l-5-5" />
      </svg>

      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="h-[14px] w-[14px] shrink-0"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
      >
        <path d="M18 6 6 18M6 6l12 12" />
      </svg>

      <span class="whitespace-nowrap">
        {{ oferta.etiqueta_estado }}
      </span>
    </div>

    <NuxtLink :href="oferta.url_landing" class="flex-shrink-0 overflow-hidden">
      <img
        :src="oferta.imagen_grilla_url"
        :alt="oferta.titulo"
        class="w-full h-[16rem] object-cover transition-all group-hover:scale-105 duration-500 will-change-transform"
        loading="lazy"
        decoding="async"
      />
    </NuxtLink>

    <div class="p-3 flex flex-col flex-grow gap-2">
      <div class="flex flex-col flex-grow justify-between">
      <span class="text-sm flex-shrink-0">{{ oferta.tipo }}</span>
        <h3 class="font-bold line-clamp-2 flex-shrink-0">{{ oferta.titulo }}</h3>
        <p class="text-sm text-GRIS_LEON line-clamp-4" v-if="oferta.parrafo_principal" v-html="oferta.parrafo_principal" />
        <p class="flex flex-col">{{ oferta.vigencia }}</p>
      </div>


      <NuxtLink
        class="w-fit self-end bg-ROJO_LEON py-2 px-3 text-white rounded-lg "
        :href="oferta.url_landing"
      >
        Ver Bases
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const config = useRuntimeConfig();
const url_cl_base = `https://${config.public.url_cl_base}`;

const props = defineProps({
  oferta: {
    type: Object,
    required: true
  }
});

const clasesEtiqueta = computed(() => {
  return props.oferta?.es_vigente
    ? 'border border-[#065F46] bg-[#ECFDF5] text-[#065F46]'
    : 'border border-[#7F1D1D] bg-[#FEF2F2] text-[#7F1D1D]';
});
</script>